
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap, } from 'rxjs/operators';
import '../../shared/extensions/extension-method.component';
import { CaptchaData } from '../models/captchaData';
import { taxFormModel, taxReviewModel } from '../models/taxFormModel'
import { CaptchaVM } from '../models/captchaVM';

interface FormValidationMessage {
  key: string;
  value: string;
}

@Injectable()
export class CertificationService {

    constructor(private httpClient: HttpClient) { }

    generateCaptchaToMemory() {

        let timeStamp = +new Date();
        let apiUrl = 'api/captcha/generateCaptchaCodeToMemory';
        let NoCachedUrl = apiUrl + '?tsp=' + timeStamp;
        apiUrl = NoCachedUrl.toServerURL(true).toString();
        return this.httpClient.get<CaptchaData>(apiUrl);
    }


    disclaimerAgree(captchaCode: CaptchaVM): Observable<any[]> {
        let timeStamp = +new Date();
        let apiUrl = 'api/captcha/validateCaptchaCode';
        // let NoCachedUrl = apiUrl + '?tsp=' + timeStamp;
        apiUrl = apiUrl.toServerURL(true).toString();
        return this.httpClient.post<any[]>(apiUrl, captchaCode);
    }


    validateRefCode(refCode: string) {
        let timeStamp = +new Date();
        let APIURL: string = "api/certification/validateReferenceCode/" + refCode;
        let NoCachedUrl = APIURL + '?tsp=' + timeStamp;
        APIURL = NoCachedUrl.toServerURL(true).toString();
        return this.httpClient.get(APIURL);
    }

    initiateTempCertification(participantid: { identifier: string }) {
        let APIURL: string = "api/certification/initiatecertification/";
        APIURL = APIURL.toServerURL(true).toString();

        return this.httpClient.post(APIURL, participantid);
    }


    removeTempAttachment(fileId: { identifier: string }) {
        let APIURL: string = "api/certification/removeTempAttachment/";
        APIURL = APIURL.toServerURL(true).toString();

        return this.httpClient.post(APIURL, fileId);
    }

    submitTaxForm(taxFormModel: taxFormModel) {
        let APIURL: string = "api/certification/submitForm/";
        APIURL = APIURL.toServerURL(true).toString();
        return this.httpClient.post(APIURL, taxFormModel);

    }

    getCertificationData(certificationId: any, refCode: string) {
        let APIURL: string = "api/certification/gettempcertification/";
        APIURL = APIURL.toServerURL(true).toString();

        return this.httpClient.post(APIURL, { tempCertificationId: certificationId, refCode: refCode}).pipe(map((response: Response) => { return response }));
    }

    getW8W9BackUrl(tempCertId: { identifier: string }) {
        let APIURL: string = "api/certification/getw8w9backurl/";
        APIURL = APIURL.toServerURL(true).toString();

        return this.httpClient.post(APIURL, tempCertId);
    }

    submitTaxReview(taxReviewModel: taxReviewModel) {

        let APIURL: string = "api/certification/submiteReview/";
        APIURL = APIURL.toServerURL(true).toString();
        return this.httpClient.post(APIURL, taxReviewModel);
    }

    getDisclaimerContent(refCode: string) {
    
        let APIURL: string = "api/settings/getdisclaimercontent/" + refCode;
        APIURL = APIURL.toServerURL(true).toString();
        return this.httpClient.get(APIURL);
    }

    getWelcomePageContent() {
        let APIURL: string = "api/settings/getwelcomepagecontent";
        APIURL = APIURL.toServerURL(true).toString();
        return this.httpClient.get(APIURL);
    }

    getAppStyleSheets() {
        let APIURL: string = "api/settings/getapplicationcss";
        APIURL = APIURL.toServerURL(true).toString();
        return this.httpClient.get(APIURL);
    }

    downloadAttachment(fileId: string, fileName: string) {
        let APIURL: string = "api/certification/downloadattachment/" + fileId;
        //APIURL = this.settingService.APIUrl + APIURL;
        APIURL = APIURL.toServerURL(true).toString();

        let headers = new Headers({ 'Authorization': "Bearer "});

        return this.httpClient.get(APIURL, { responseType: 'blob' })
            
            .subscribe(blob => {

                const blobObject = new Blob([blob], { type: 'application/octet-stream' });

                if (navigator && (navigator as any).msSaveOrOpenBlob) {
                    // For Internet Explorer (older versions)
                    (navigator as any).msSaveOrOpenBlob(blobObject, fileName);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blobObject);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                }
            });
    }
}
